import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Hungary",
  "use": "icon-Hungary-usage",
  "viewBox": "0 0 1531 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1531 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-Hungary\"><path d=\"M0.746351 1023.247678h1528.527531V2.239054H0.746351z\" fill=\"#C0282F\" p-id=\"24334\" /><path d=\"M0.746351 1023.247678h1528.527531V342.581233H0.746351z\" fill=\"#FFFFFE\" p-id=\"24335\" /><path d=\"M0 1024h1528.52753V683.657821H0z\" fill=\"#0E8343\" p-id=\"24336\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol